export default __webpack_public_path__ + "static/media/item4.f30c598d.jpg";